(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "./Loading", "../icon", "../tag"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("./Loading"), require("../icon"), require("../tag"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.Loading, global.icon, global.tag);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _Loading, _icon, _tag) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _Loading = _interopRequireDefault(_Loading);
  _icon = _interopRequireDefault(_icon);
  _tag = _interopRequireDefault(_tag);

  var _components;

  var timer = null;
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('button', {
        staticClass: "fos-button",
        class: ['fos-button--' + _vm.type, 'fos-button--' + _vm.size, 'fos-button--' + _vm.status, {
          'is-disabled': _vm.disabled,
          'is-loading-disabled': _vm.loadingDisabled,
          'is-inline': _vm.inline,
          'is-loading': _vm.showLoading,
          'has-preIcon': _vm.preIcon
        }, _vm.position ? "fos-button--" + _vm.size + "-" + _vm.position : ''],
        style: {
          '--fos-button-lineColor': _vm.lineColor,
          '--fos-button-faceColor': _vm.faceColor,
          '--fos-button-textColor': _vm.textColor,
          '--fos-button-lineColorDark': _vm.lineColorDark || _vm.lineColor,
          '--fos-button-faceColorDark': _vm.faceColorDark || _vm.faceColor,
          '--fos-button-textColorDark': _vm.textColorDark || _vm.textColor
        },
        attrs: {
          "type": _vm.nativeType,
          "disabled": _vm.disabled || _vm.loading
        },
        on: {
          "click": _vm.handleClick,
          "touchstart": _vm.onTouchStart,
          "touchend": _vm.onTouchEnd
        }
      }, [_c('div', {
        staticClass: "fos-button-content"
      }, [_c('div', {
        staticClass: "fos-button-text",
        class: {
          'icon-fab': _vm.type == 'fab' && !_vm.$slots.fabText
        }
      }, [_vm.preIcon ? [_c('nx-icon', {
        staticClass: "fos-button-icon",
        attrs: {
          "name": _vm.preIcon
        }
      })] : _vm._e(), _vm._t("default"), _vm.$slots.fabText ? _vm._t("fabText") : _vm._e(), _vm.showLoading && _vm.size === 'small' ? [_c('img', {
        staticClass: "fos-button-loading__small",
        attrs: {
          "alt": "",
          "src": require('../_style/images/smallButttonLoading.png')
        }
      })] : _vm.showLoading ? [_c('button-loading', {
        staticClass: "fos-button-loading"
      })] : _vm.icon ? [_c('nx-icon', {
        staticClass: "fos-button-icon",
        attrs: {
          "name": _vm.icon,
          "svg": _vm.iconSvg
        }
      })] : _vm._e()], 2)]), _vm.tagProps.content ? [_c('nx-tag', _vm._b({
        staticClass: "fos-button-tag"
      }, 'nx-tag', _vm.tagProps, false))] : _vm._e()], 2);
    },
    name: 'fos-button',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _icon.default.name, _icon.default), (0, _defineProperty2.default)(_components, _Loading.default.name, _Loading.default), (0, _defineProperty2.default)(_components, _tag.default.name, _tag.default), _components),
    props: {
      icon: String,
      preIcon: String,
      disabled: Boolean,
      nativeType: String,
      position: {
        type: String,
        default: '',
        validator: function validator(value) {
          return ['bottom', 'center'].indexOf(value) > -1 || !value;
        }
      },
      inline: Boolean,
      loading: Boolean,
      delay: Number,
      type: {
        type: String,
        default: 'default',
        validator: function validator(value) {
          return ['default', 'general', 'primary', 'disabled', 'link', 'dialog-link', 'cancel', 'frame', 'danger', 'frame-plus', 'danger-plus', 'toggle', // 状态按钮
          'fab' // 悬浮按钮
          ].indexOf(value) > -1;
        }
      },
      size: {
        type: String,
        default: 'normal',
        validator: function validator(value) {
          return ['small', 'medium', 'normal', 'large'].indexOf(value) > -1;
        }
      },
      // 状态按钮的选中态
      selected: {
        type: Boolean,
        default: false
      },
      lineColor: {
        type: String,
        default: ''
      },
      faceColor: {
        type: String,
        default: ''
      },
      textColor: {
        type: String,
        default: ''
      },
      lineColorDark: {
        type: String,
        default: ''
      },
      faceColorDark: {
        type: String,
        default: ''
      },
      textColorDark: {
        type: String,
        default: ''
      },
      bgColor: {
        type: String,
        default: ''
      },
      tagProps: {
        type: Object,
        default: function _default() {
          return {
            shape: 'sharp'
          };
        }
      }
    },
    computed: {
      status: function status() {
        return this.selected ? 'selected' : 'unselected';
      }
    },
    data: function data() {
      return {
        showLoading: false,
        loadingDisabled: false
      };
    },
    watch: {
      loading: function loading(status) {
        var _this = this;

        var isPrimaryLoading = this.type === 'primary' && (this.size === 'large' || this.size === 'normal');
        var isSmallLoading = this.size === 'small';

        if (status) {
          // 处理大按钮的loading
          if (isPrimaryLoading) {
            timer = setTimeout(function () {
              _this.showLoading = true;
            }, this.delay || 200);
          } // 处理小按钮的loading


          if (isSmallLoading) {
            timer = setTimeout(function () {
              _this.showLoading = true;
              _this.loadingDisabled = true;
            }, this.delay || 200);
          }
        } else {
          clearTimeout(timer);
          timer = null;
          isSmallLoading && (this.loadingDisabled = false);
          this.showLoading = false;
        }
      }
    },
    beforeDestroy: function beforeDestroy() {
      clearTimeout(timer);
      timer = null;
      this.showLoading = false;
    },
    methods: {
      onTouchEnd: function onTouchEnd(e) {
        this.$emit('touchend', e);
      },
      onTouchStart: function onTouchStart() {
        if (this.disabled) {
          this.$emit('disableClickFeedback');
        }
      },
      handleClick: function handleClick(e) {
        this.$emit('click'); // 不能传参数出去，业务中大规模使用

        this.$emit('clickWithEvent', e); // 注意，以后涉及click事件等，必须要把e传出去
      }
    }
  };
  _exports.default = _default2;
});